/**
 * Only ever hand an http(s) URL to `href`.
 *
 * `trackingUrl` and `labelUrl` are server data written by whatever created the shipment (carrier
 * callback, provider metadata, a merchant's manual entry) — not values this app controls. React
 * does not block a `javascript:` href, so rendering one unchecked turns a courier field into a
 * script sink, and a `data:`/`vbscript:` URL is the same problem wearing a different scheme.
 * Anything that is not http/https becomes plain text with no link.
 */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  const trimmed = raw?.trim()
  // A whitespace-only value must fail here: `new URL('', origin)` resolves to the origin itself,
  // which would render a live link to our own dashboard as if it were a tracking URL.
  if (!trimmed) return null
  try {
    // Parsed, not regex-matched: `java\nscript:` and `%6Aavascript:` both survive naive matching
    // but normalise here, and a relative URL resolves against the page rather than being trusted.
    const url = new URL(trimmed, window.location.origin)
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null
  } catch {
    return null
  }
}
